module.exports = "../fonts/WhitneyBold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/WhitneyBold.otf
// module id = 588
// module chunks = 0